import { objectToArrayWithKeyValue } from 'helpers';
export const masters = {
    Admin: 0,
    Center: 1,
    Branch: 2,
    Section: 3
};
export const masterOptions = objectToArrayWithKeyValue(masters);
